import type {CoreExportFormat} from '@wix/document-services-types'
import type {DecorationPluginFunction} from '../../types'
import {getVersion} from '../../utils/version'

export const pack: DecorationPluginFunction = (componentExport: CoreExportFormat) => {
    componentExport.version = getVersion()
}
